export default "__VITE_ASSET__Ct25_8vZ__"